import { render, staticRenderFns } from "./documents.withholdingTax.vue?vue&type=template&id=0036cdc0&scoped=true"
import script from "./documents.withholdingTax.vue?vue&type=script&lang=js"
export * from "./documents.withholdingTax.vue?vue&type=script&lang=js"
import style0 from "./documents.withholdingTax.vue?vue&type=style&index=0&id=0036cdc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036cdc0",
  null
  
)

export default component.exports